import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Toast from './toast';
import './index.scss';

export interface Istate {
    notices: any[];
}
export interface Iprops {}
// notice 用于保存当前页面中存在的 Notice 的信息。
// Notification 组件拥有 addNotice 和 removeNotice 两个方法，用于向 notices 中添加和移除 Notice 的信息

export default class Notification extends React.Component<Iprops, Istate> {
    constructor(props: Iprops) {
        super(props);
        this.state = { notices: [] };
    }
    getNoticeKey() {
        const { notices } = this.state;
        return `notice-${new Date().getTime()}-${notices.length}`;
    }
    addNotice = (notice: any) => {
        const { notices } = this.state;
        notice.key = this.getNoticeKey();
        if (notices.every((item) => item.key !== notice.key)) {
            notices[0] = notice;
            this.setState({ notices });
            if (notice.duration > 0) {
                setTimeout(() => {
                    this.removeNotice(notice.key);
                }, notice.duration);
            }
        }
    };

    removeNotice = (key: string) => {
        this.setState((previousState) => ({
            notices: previousState.notices.filter((notice) => {
                if (notice.key === key) {
                    if (notice.onClose) notice.onClose();
                    return false;
                }
                return true;
            }),
        }));
    };
    render() {
        const { notices } = this.state;
        return (
            <TransitionGroup className="c-toast-notification">
                {notices.map((notice) => (
                    <CSSTransition
                        key={notice.key}
                        classNames="c-toast-notice-wrapper c-fade"
                        // timeout={this.transitionTime}
                        timeout={notice.duration}
                    >
                        <Toast {...notice} />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        );
    }
}
